import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Paper,
  Box,
  Button,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const STATUS_COLORS = {
  PENDING: "#FFD86C",
  APPROVED: "#89C27A",
  REJECTED: "#F88585",
};

const VIEW_BUTTON_STYLE = {
  bgcolor: "#a1cac4",
  color: "#000",
  "&:hover": {
    bgcolor: "#91b4af",
  },
  textTransform: "none",
  borderRadius: 0.5,
  minWidth: "90px",
  height: "32px",
  fontSize: "16px",
};

const AmendmentTable = ({
  amendments = [],
  loading,
  onEdit,
  onDelete,
  onViewReason,
  onViewNotes,
  // onStatusClick,
  onReview,
  canApprove,
  canEdit,
  canDelete,
  page = 0,
  rowsPerPage = 10,
  totalRows = 0,
  onPageChange,
  onRowsPerPageChange,
}) => {
  if (loading) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: 600,
        overflow: "auto",
        border: "1px solid #ddd",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        margin: "20px auto",
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              bgcolor: "#124F3E",
              "& .MuiTableCell-root": {
                color: "white",
                fontWeight: "bold",
                textWrap: "nowrap",
              },
            }}
          >
            <TableCell sx={{ bgcolor: "#124F3E" }}>S.No.</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Projection</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Product</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Projected Quantity</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Proposed Quantity</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Reason</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Status</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Reviewer Notes</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Proposed By</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Reviewed By</TableCell>
            <TableCell sx={{ bgcolor: "#124F3E" }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {amendments.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell>{page * rowsPerPage + index + 1}</TableCell>
              <TableCell>{row.projection}</TableCell>
              <TableCell>{row.product}</TableCell>
              <TableCell>{row.projectedQuantity}</TableCell>
              <TableCell>{row.proposedQuantity}</TableCell>
              <TableCell>
                {row.reason && row.reason !== "N/A" ? (
                  <Button
                    variant="contained"
                    sx={VIEW_BUTTON_STYLE}
                    size="small"
                    onClick={() => onViewReason(row)}
                  >
                    View
                  </Button>
                ) : (
                  "N/A"
                )}
              </TableCell>
              <TableCell>
                <Button
                  size="small"
                  variant="contained"
                  // onClick={() => onEdit({ ...row, action: "review" })}
                  onClick={() => onReview(row)}
                  sx={{
                    bgcolor: STATUS_COLORS[row.status],
                    color: row.status === "PENDING" ? "#000" : "#fff",
                    "&:hover": {
                      bgcolor: STATUS_COLORS[row.status],
                      opacity: 0.9,
                    },
                    textTransform: "none",
                    minWidth: "90px",
                    height: "32px",
                    borderRadius: 0.5,
                    fontSize: "16px",
                  }}
                  disabled={!canApprove}
                >
                  {row.status}
                </Button>
              </TableCell>
              <TableCell>
                {row.reviewerNotes && row.reviewerNotes !== "N/A" ? (
                  <Button
                    variant="contained"
                    sx={VIEW_BUTTON_STYLE}
                    size="small"
                    onClick={() => onViewNotes(row)}
                  >
                    View
                  </Button>
                ) : (
                  "N/A"
                )}
              </TableCell>
              <TableCell>{row.proposedBy}</TableCell>
              <TableCell>{row.reviewedBy}</TableCell>

              <TableCell>
                {row.status && row.status !== "APPROVED" && row.status !== "REJECTED" ? (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <IconButton
                      size="small"
                      // onClick={() => onEdit({ ...row, action: "edit" })}
                      onClick={() => onEdit(row)}
                      sx={{ color: "#124F3E" }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => onDelete(row)}
                      sx={{ color: "#124F3E" }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </TableContainer>
  );
};

export default AmendmentTable;
